// $(document).ready(function () {
// 	$('#sidebarCollapse').on('click', function () {
// 	    $('#sidebar').toggleClass('active');
// 	});
// });
// if no Webkit browser
// (function(){
//   let isChrome = /Chrome/.test(navigator.userAgent) && /Google Inc/.test(navigator.vendor);
//   let isSafari = /Safari/.test(navigator.userAgent) && /Apple Computer/.test(navigator.vendor);
//   let scrollbarDiv = document.querySelector('.scrollbar');
//     if (!isChrome && !isSafari) {
//       scrollbarDiv.innerHTML = 'You need Webkit browser to run this code';
//     }
// })();
/*expander div*/

 $(function() {
   $('.expander').on("click", function() {
       var isActive = $(this).is('.active');
       $(this).toggleClass('active', !isActive);
   });  
});

 $(function() {
   $('.expanderTR').on("click", function() {
       $(this).closest('.selectHere').toggleClass('active');

   });  
});

 $(document).ready(function(){
    var elements = [];

    $(".scroll-to-link").click(function(e) { 
        e.preventDefault(); 
        var id = $(this).attr('data-target');
        $('html,body').animate({scrollTop: $("#"+id).offset().top - 20});
        return false;
    });
    
    function calculElements(){
        var total_height = 0;
        elements = [];
        $('.content-section').each(function(){
            var the_section = {};
            the_section.id = $(this).attr('id').replace('content-', '');
            total_height +=  $(this).height();
            the_section.max_height = total_height;
            elements.push(the_section);
        });
    }
    
    function onScroll(){
        var scroll = $(window).scrollTop(); 
        for (var i = 0; i < elements.length; i++) {
            var the_section = elements[i];
            if(scroll <= the_section.max_height){
                $(".content-menu ul li").removeClass('active');
                $( ".content-menu ul li[data-target='"+the_section.id+"']" ).addClass('active');   
                break;
            }
        }
        if(scroll + $(window).height() == $(document).height()) { // end of scroll, last element
            $(".content-menu ul li").removeClass('active');
            $( ".content-menu ul li:last-child" ).addClass('active');   
        }
    }

    calculElements();
    $(window).resize(function(e){
        e.preventDefault(); 
        calculElements();
    });
    
    $(window).on('scroll', function(e) {
        e.preventDefault();
        onScroll();
    });
});


//////////////////
// WEBPACK FOOTER
// ./static/fxView/js/custom.js
// module id = IUqX
// module chunks = 4